<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.reportsContactsAnalysis')}}</b></span><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12>
				<v-icon small>fa-info-circle</v-icon><span style="display:inline-block; padding-left:10px; color:grey; font-size:13px;">{{$t('labels.reportsWaitTime')}}</span><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs3>
				<v-layout row wrap>
					<v-flex md6 xs12>
						<v-btn color="grey lighten-1" @click="deleteFilters" style="width:95%">
							{{ $t('buttons.deleteFilters') }}
						</v-btn><br>
					</v-flex>
					<v-flex md6 xs12>
						<v-btn color="grey lighten-1" @click="getData" style="width:95%">
							{{ $t('buttons.fetchData') }}
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs12 text-md-right text-xs-right>
				<v-tooltip bottom>
				<v-btn @click="excelExport" icon slot="activator">
					<v-icon small>fa-file-excel</v-icon>
				</v-btn>
				<span>{{$t('tooltips.excel')}}</span>
			</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-1>
			<v-flex xs12>
				<DataTable
						ref="dataTable"
						:excel="false"
						:headers="contactsTable.headers"
						:items="contactsTable.items"
						:total="contactsTable.total"
						@reload="reloadData"
						@excel="excelExport"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.link, false)">{{ props.item.contact_name }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.first_contact }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.last_contact }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.lead_source }}</td>
								<td @click="editClick(props.item.link, false)">
									<v-icon small v-if="props.item.pairing">fa-check</v-icon>
								</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_offerings }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_views }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_canceled_views }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.total_offers_recieved }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.budget }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.type_of_realesate }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.assigned_to }}</td>
								<td @click="editClick(props.item.link, false)">
									<v-icon small v-if="props.item.left_review">fa-check</v-icon>
								</td>
								<td @click="editClick(props.item.link, false)">
									<v-icon small v-if="props.item.looking_for_realestate">fa-check</v-icon>
								</td>
								<td @click="editClick(props.item.link, false)">
									<v-icon small v-if="props.item.bought_our_realestate">fa-check</v-icon>
								</td>
							</tr>
						</template>
					</DataTable>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTable from "./trinkets/DataTable";
import InputField from "./trinkets/InputField";

export default {
	name: "ReportsContactsAnalysis",
	components: {DataTable, InputField},
	data: function () {
		return {
			contactsTable: {
				headers: [
					{text: this.$t('fields.contactName'), value: 'contact_name', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.firstContact'), value: 'first_contact', type: 'date_range', searchable: 'hidden'},
					{text: this.$t('fields.lastContact'), value: 'last_contact', type: 'date_range', searchable: 'hidden'},
					{text: this.$t('fields.leadSource'), value: 'lead_source', type: 'multiple|lead-source', searchable: 'hidden'},
					{text: this.$t('fields.pairing'), value: 'pairing', type: 'boolean', searchable: 'hidden'},
					{text: this.$t('fields.totalOfferedRealestate'), value: 'total_offerings', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.totalViewsCompleted'), value: 'total_views', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.totalViewsCanceled'), value: 'total_canceled_views', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.totalOffersRecieved'), value: 'total_offers_recieved', type: 'number_range', searchable: 'hidden'},
					{text: this.$t('fields.budget'), value: 'budget', type: 'price_range', searchable: 'hidden'},
					{text: this.$t('fields.typeOfRealestate'), value: 'type_of_realesate', type: 'string', searchable: 'hidden'},
					{text: this.$t('fields.assignedTo'), value: 'assigned_to', type: 'multiple|assigned-people', searchable: 'hidden'},
					{text: this.$t('fields.leftReview'), value: 'left_review', type: 'boolean', searchable: 'hidden'},
					{text: this.$t('fields.lookingForRealestate'), value: 'looking_for_realestate', type: 'boolean', searchable: 'hidden'},
					{text: this.$t('fields.boughtOurRealestate'), value: 'bought_our_realestate', type: 'boolean', searchable: 'hidden'},
				],
				items: [],
				total: 0,
				lastRequest: null
			}
		}
	},
	methods: {
		deleteFilters(){
			let dataTable = this.$refs.dataTable;
			dataTable.resetFilter();
			dataTable.filter = false;
		},
		getData(){
			let dataTable = this.$refs.dataTable;
			dataTable.filter = false;
			let vm = this;
			this.$APICall('get', 'report-contact-analysis', this.lastRequest, (data, success) => {
				if (success) {
					vm.contactsTable.items = data.items;
					vm.contactsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		reloadData(request) {
			this.lastRequest = request;
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
			excelRequest.pagination.rowsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall('get', 'report-contact-analysis', excelRequest, (data, success) => {
				if (success) {
					vm.$APICall('post', 'excel/report-contact-analysis', data.items, (data, success) => {
						window.open(data.link);
					});
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		editClick(link){
			if(link != null && link != ''){
				window.open(link);
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
